import axios from 'axios'
import { handleApiError } from '@/utils/apiHelpers'

export default {
    getProcessSubjects({ commit }, query = '') {

        return axios
            .get(`/wiki/process-subjects${query}`)
            .then(response => {
                commit('GET_PROCESS_SUBJECTS_SUCCESS', response.data)

                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Pobranie listy folderów nie powiodło się.')

                return Promise.reject(error)
            })
    },
    getProcessEntries({ commit }) {

        return axios
            .get('/wiki/process-entries')
            .then(response => {
                commit('GET_PROCESS_ENTRIES_SUCCESS', response.data)

                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Pobranie listy wpisów nie powiodło się.')

                return Promise.reject(error)
            })
    },
    saveProcessSubject({ commit }, processSubjectData) {
        return axios
            .post('/wiki/process-subjects', processSubjectData)
            .then(response => {
                commit('SHOW_NOTIFICATION', {
                    type: 'success',
                    message: 'Folder został dodany.'
                }, { root: true })

                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Dodanie folderu nie powiodło się.')

                return Promise.reject(error)
            })
    },
    getProcessSubject(context, payload = {
        processSubjectId: null,
        query: ''
    }) {
        const subjectId = payload.processSubjectId,
            query = payload.query

        return axios
            .get(`/wiki/process-subjects/${subjectId}${query}`)
            .then(response => {
                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, `Pobranie danych do folderu ${subjectId} nie powiodło się.`)

                return Promise.reject(error)
            })
    },
    saveProcessEntry({ commit }, processEntryData) {
        return axios
            .post('/wiki/process-entries', processEntryData)
            .then(response => {
                commit('SHOW_NOTIFICATION', {
                    type: 'success',
                    message: 'Wpis został dodany.'
                }, { root: true })

                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Dodanie wpisu nie powiodło się.')

                return Promise.reject(error)
            })
    },
    getProcessEntry({ commit }, processEntryId) {
        return axios
            .get(`/wiki/process-entries/${processEntryId}`)
            .then(response => {
                commit('GET_PROCESS_ENTRY_SUCCESS', response.data)

                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, `Pobranie danych do wpisu ${processEntryId} nie powiodło się.`)

                return Promise.reject(error)
            })
    },
    deleteProcessEntry({ commit }, processEntryId) {
        return axios
            .delete(`/wiki/process-entries/${processEntryId}`)
            .then(response => {
                commit('SHOW_NOTIFICATION', {
                    type: 'success',
                    message: 'Wpis został usunięty.'
                }, { root: true })

                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Usunięcie wpisu nie powiodło się.')

                return Promise.reject(error)
            })
    },
    updateProcessEntry({ commit }, processEntryData) {
        return axios
            .put(`/wiki/process-entries/${processEntryData.id}`, processEntryData)
            .then(response => {
                commit('SHOW_NOTIFICATION', {
                    type: 'success',
                    message: 'Wpis został zedytowany.'
                }, { root: true })

                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Zapis nie powiódł się.')

                return Promise.reject(error)
            })
    },
    deleteProcessSubject({ commit }, processSubjectId) {
        return axios
            .delete(`/wiki/process-subjects/${processSubjectId}`)
            .then(response => {
                commit('SHOW_NOTIFICATION', {
                    type: 'success',
                    message: 'Folder został usunięty.'
                }, { root: true })

                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Usunięcie folderu nie powiodło się.')

                return Promise.reject(error)
            })
    },
    createAttachment(context, formData) {
        return axios
            .post('/wiki/process-entries/upload', formData)
            .then(response => {
                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Dodanie załącznika nie powiodło się.')

                return Promise.reject(error)
            })
    },
    deleteAttachment({ commit }, attachmentId) {
        return axios
            .delete(`/wiki/process-entries/upload/${attachmentId}`)
            .then(response => {
                commit('SHOW_NOTIFICATION', {
                    type: 'success',
                    message: 'Załącznik został usunięty.'
                }, { root: true })

                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Usunięcie załącznika nie powiodło się.')

                return Promise.reject(error)
            })
    },
    setWikiFilters({ commit }, filters) {
        commit('SET_WIKI_FILTERS', filters)
    },
    clearWikiFilters({ commit }) {
        commit('CLEAR_WIKI_FILTERS')
    }
}